const actions = {
  
  VOLUNTEER_APPLICATIONS_READ_BEGIN: 'VOLUNTEER_APPLICATIONS_READ_BEGIN',
  VOLUNTEER_APPLICATIONS_READ_SUCCESS: 'VOLUNTEER_APPLICATIONS_READ_SUCCESS',
  VOLUNTEER_APPLICATIONS_READ_ERR: 'VOLUNTEER_APPLICATIONS_READ_ERR',
  
  VOLUNTEER_APPLICANTS_READ_BEGIN: 'VOLUNTEER_APPLICANTS_READ_BEGIN',
  VOLUNTEER_APPLICANTS_READ_SUCCESS: 'VOLUNTEER_APPLICANTS_READ_SUCCESS',
  VOLUNTEER_APPLICANTS_READ_ERR: 'VOLUNTEER_APPLICANTS_READ_ERR',

  VOLUNTEER_APPLICATION_DELETE_BEGIN: 'VOLUNTEER_APPLICATION_DELETE_BEGIN',
  VOLUNTEER_APPLICATION_DELETE_SUCCESS: 'VOLUNTEER_APPLICATION_DELETE_SUCCESS',
  VOLUNTEER_APPLICATION_DELETE_ERR: 'VOLUNTEER_APPLICATION_DELETE_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.VOLUNTEER_APPLICATIONS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.VOLUNTEER_APPLICATIONS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.VOLUNTEER_APPLICATIONS_READ_ERR,
      err,
    };
  },

  axiosApplicantsReadBegin: () => {
    return {
      type: actions.VOLUNTEER_APPLICANTS_READ_BEGIN,
    };
  },

  axiosApplicantsReadSuccess: data => {
    return {
      type: actions.VOLUNTEER_APPLICANTS_READ_SUCCESS,
      data,
    };
  },

  axiosApplicantsReadErr: err => {
    return {
      type: actions.VOLUNTEER_APPLICANTS_READ_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.VOLUNTEER_APPLICATION_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.VOLUNTEER_APPLICATION_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.VOLUNTEER_APPLICATION_DELETE_ERR,
      err,
    };
  }

};

export default actions;
